import { useState } from "react";
import type { LayoutChangeEvent } from "react-native";

// The ONE "does this text fit its box" measurement (MarqueeText, and the
// failed-set caption of EffortTimerSlot): the box reports its width and an
// unconstrained copy of the text reports its natural width, both from
// onLayout, so RN and RNW agree and nothing depends on the platform.
//
// The text to measure must be laid out WITHOUT the box's constraint: render
// it in a row `MEASURE_WIDTH` wide (a visible track, or an invisible twin kept
// out of the flow), so it never wraps the text it measures.

/** Wide enough that the measuring row never wraps the text it measures. */
export const MEASURE_WIDTH = 4000;

/** `inset`: what the box's onLayout width includes but its content does not
 *  (a border, on each side). */
export function useTextFit(inset = 0) {
  const [boxW, setBoxW] = useState(0);
  const [textW, setTextW] = useState(0);
  const overflow = Math.max(0, Math.ceil(textW - (boxW - 2 * inset)));
  return {
    boxW,
    textW,
    /** Natural width minus room, in px; 0 = it fits (or nothing measured yet). */
    overflow,
    /** Both measured, and the text fits. */
    fits: boxW > 0 && textW > 0 && overflow === 0,
    onBoxLayout: (e: LayoutChangeEvent) => setBoxW(e.nativeEvent.layout.width),
    onTextLayout: (e: LayoutChangeEvent) =>
      setTextW(e.nativeEvent.layout.width),
  };
}
